import { Link } from "react-router-dom";
import { clinicInfo } from "../data";

export default function PakkeforloebPage() {
  const heroImg = "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/behandlerrum-kiroprator-assens_1.jpg";
  const secondaryImg = "https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/p1060635_1.jpg";

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      {/* Breadcrumb */}
      <nav className="flex mb-8 text-sm text-brand-600 font-medium">
        <Link to="/" className="hover:text-brand-800">Forside</Link>
        <span className="mx-2">/</span>
        <span className="text-brand-900 font-semibold">Pakkeforløb</span>
      </nav>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        {/* Main Content (8 cols) */}
        <article className="lg:col-span-8 space-y-12 text-left">
          {/* Hero Image */}
          <div className="overflow-hidden rounded-3xl border border-brand-100 shadow-md">
            <img
              src={heroImg}
              alt="Behandlingsrum Kiropraktisk Klinik Assens"
              className="w-full h-[400px] object-cover object-center"
            />
          </div>

          {/* Intro Section */}
          <div className="space-y-6">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-brand-950 leading-tight">
              Pakkeforløb for diskusprolaps & spinalstenose
            </h1>
            <h2 className="text-2xl font-bold font-display text-brand-800">
              Få et forløb hos kiropraktor
            </h2>
            <p className="text-lg text-brand-800 leading-relaxed">
              Det er vigtigt at søge behandling med det samme, når der er mistanke om en diskusprolaps. Dette kan være afgørende for optimal behandling og kan sikre en kortere behandlingsperiode. Dog kan behandling ikke undgås, og der findes derfor tilskud til et pakkeforløb.
            </p>
          </div>

          {/* Section: Du kan godt komme dig */}
          <div className="space-y-6 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Du kan godt komme dig efter en diskusprolaps
            </h2>
            <p className="text-brand-800 leading-relaxed">
              Langt de fleste kan komme sig efter en diskusprolaps med den rette behandling og undgå operation, men det afhænger af, hvornår man opsøger professionel behandling. Det er vigtigt, at du ikke går for længe med det og tager kontakt til en læge eller kiropraktor, hvis du har mistanke om en diskusprolaps.
            </p>
          </div>

          {/* Section: Et pakkeforløb tilpasset dig */}
          <div className="space-y-6 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Et pakkeforløb tilpasset dig
            </h2>
            <p className="text-brand-800 leading-relaxed">
              Du kan være i pakkeforløb i op til et halvt år. Det kræver dog, at du som minimum kommer til tjek efter 2, 4 og 8 uger. Ellers ryger du ud af forløbet og får ikke længere det forhøjede tilskud.
            </p>
            <p className="text-brand-800 leading-relaxed">
              Der findes et lignende pakkeforløb for dig, der har forsnævring af rygmarvskanalen (spinalstenose).
            </p>
          </div>

          {/* Section: Behandling og tilskud */}
          <div className="space-y-8 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Behandling og tilskud
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
              <div className="md:col-span-7 space-y-6">
                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-brand-900">Tilskud fra den offentlige sygesikring</h3>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Med et pakkeforløb for en diskusprolaps giver den offentlige sygesikring et væsentligt forhøjet tilskud til patienter, så de kan behandles over en længerevarende periode. Dette giver din kiropraktor mulighed for at følge dig tæt gennem forløbet og give dig den bedste behandling.
                  </p>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Diskusprolaps er i første omgang en klinisk diagnose. Det betyder, at det er klinikeren – i dette tilfælde kiropraktoren – der stiller diagnosen uden MR-scanning. Ved mistanke om prolaps, kommer du i et pakkeforløb, hvor kiropraktoren holder øje med symptomudviklingen, giver gode råd og vejleder dig gennem forløbet. Hvor det normalt er lægen, der er tovholder, er det her kiropraktoren, der står for at informere lægen, henvise til scanning, hvis det bliver nødvendigt osv.
                  </p>
                </div>

                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-brand-900">Døjer du med smerter i ryggen?</h3>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Rygsmerter betyder selvfølgelig ikke altid en diskusprolaps. Døjer du med tilbagevendende eller kroniske rygsmerter, er det dog vigtigt at blive tilset af eksperter, så problemet ikke forværres.
                  </p>
                </div>
              </div>

              <div className="md:col-span-5 space-y-6">
                <div className="overflow-hidden rounded-2xl border border-brand-100 shadow-sm aspect-4/3">
                  <img
                    src={secondaryImg}
                    alt="Pakkeforløb undersøgelse"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="bg-brand-50 p-6 rounded-2xl border border-brand-100 text-center">
                  <p className="text-sm text-brand-900 font-semibold mb-3">Har du brug for akut tid?</p>
                  <a
                    href={clinicInfo.bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex w-full items-center justify-center rounded-full bg-brand-600 py-2.5 text-sm font-bold text-white shadow-xs hover:bg-brand-700 transition-colors cursor-pointer"
                  >
                    Bestil tid online
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Section: Specifikke tilstande */}
          <div className="space-y-6 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Forstå de forskellige diagnoser
            </h2>

            <div className="space-y-6">
              <div className="bg-brand-50/30 p-6 rounded-2xl border border-brand-100/60 space-y-2">
                <h3 className="font-bold text-brand-900 text-lg">Diskusprolaps i lænden</h3>
                <p className="text-sm text-brand-800 leading-relaxed">
                  Diskusprolaps i lænden er almindeligt og rammer mange forskellige mennesker. Lændesmerter er generelt et almindeligt problem hos den danske befolkning, men skal adskilles fra en reel diskusprolaps. De irriterede nerver i lænden kan være grundet en bule i den brusk, der sidder mellem to ryghvirvler. Nerverne går ud i benet, og der kan opstå smerter, sovende fornemmelser og nedsat funktion i benet, når man har en diskusprolaps.
                </p>
                <p className="text-xs pt-1">
                  <a href="http://www.kiropraktorguide.dk/diskusprolaps" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline font-semibold">
                    Læs mere på Kiropraktorguide.dk/diskusprolaps <i className="fa-solid fa-arrow-up-right-from-square text-[10px] ml-1" />
                  </a>
                </p>
              </div>

              <div className="bg-brand-50/30 p-6 rounded-2xl border border-brand-100/60 space-y-2">
                <h3 className="font-bold text-brand-900 text-lg">Diskusprolaps i nakken</h3>
                <p className="text-sm text-brand-800 leading-relaxed">
                  Diskusprolaps i nakken er irritation af nerver, der går ud i armen. Her kan der være tale om en udbuling i brusken mellem to hvirvler i nakken eller forsnævring omkring nakkeled – også kaldet foraminal stenose. Da nerverne forbindes med armen, kan symptomer være smerter, snurren og nedsat funktion i både arm, skulder og hånd.
                </p>
                <p className="text-xs pt-1">
                  <a href="http://www.kiropraktorguide.dk/nakke" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline font-semibold">
                    Læs mere på Kiropraktorguide.dk/nakke <i className="fa-solid fa-arrow-up-right-from-square text-[10px] ml-1" />
                  </a>
                </p>
              </div>

              <div className="bg-brand-50/30 p-6 rounded-2xl border border-brand-100/60 space-y-2">
                <h3 className="font-bold text-brand-900 text-lg">Spinal stenose</h3>
                <p className="text-sm text-brand-800 leading-relaxed">
                  Spinal stenose ses typisk med aldersforandringer i lænderyggen, hvor der opstår mindre plads i rygmarvskanalen. Det kaldes også rygmarvsforsnævring og betyder, at de nerver, som går ned til benene, har for lidt plads. Dette påvirker ryggen i form af smerter samt nedsat føling og træthed i benene, specielt når man går og står, mens det lindres, når man sidder eller bøjer sig forover.
                </p>
                <p className="text-xs pt-1">
                  <a href="http://www.kiropraktorguide.dk/stenose" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline font-semibold">
                    Læs mere på Kiropraktorguide.dk/stenose <i className="fa-solid fa-arrow-up-right-from-square text-[10px] ml-1" />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* Sidebar (4 cols) */}
        <aside className="lg:col-span-4 space-y-8 text-left sticky top-24">
          {/* Booking Card */}
          <div className="rounded-3xl bg-brand-900 text-white p-8 shadow-lg space-y-6">
            <h3 className="text-xl font-bold font-display text-white">Bestil tid i dag</h3>
            <p className="text-sm text-brand-200 leading-relaxed">
              Døjer du med smerter eller nedsat bevægelighed? Bestil en tid online eller ring til os for en uforpligtende snak.
            </p>
            <div className="space-y-4 pt-2">
              <a
                href={clinicInfo.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full items-center justify-center rounded-full bg-white py-3.5 text-sm font-bold text-brand-900 shadow-sm hover:bg-brand-50 transition-all duration-200 hover:scale-102 active:scale-98 cursor-pointer"
              >
                Bestil tid online
              </a>
              <a
                href={`tel:${clinicInfo.phone}`}
                className="flex w-full items-center justify-center rounded-full bg-brand-800 border border-brand-700 py-3.5 text-sm font-bold text-white hover:bg-brand-700 transition-colors cursor-pointer"
              >
                <i className="fa-solid fa-phone mr-2" />
                <span className="whitespace-nowrap">{clinicInfo.phone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4")}</span>
              </a>
            </div>
          </div>

          {/* Opening Hours Card */}
          <div className="rounded-3xl bg-white border border-brand-100 p-8 shadow-xs space-y-6">
            <h3 className="text-lg font-bold font-display text-brand-950 border-b border-brand-100 pb-3">
              Åbningstider
            </h3>
            <div className="space-y-3 text-sm text-brand-800">
              {clinicInfo.openingHours.map((item) => (
                <div key={item.day} className="flex justify-between border-b border-brand-50 pb-1.5">
                  <span>{item.day}</span>
                  <span className="font-semibold text-brand-900">{item.hours}</span>
                </div>
              ))}
              <div className="pt-2 text-xs text-brand-600">
                <p className="font-semibold text-brand-800">Telefontider:</p>
                <p className="mt-1">{clinicInfo.telefontider}</p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
